module.exports = __webpack_public_path__ + "img/AT0000027738994.3c8e1345.png";